import { BankAccountVerificationStatus } from 'api/employeeBankAccount';
import { BadgeProps } from '@razorpay/blade/components';
import { bankAccountVerificationStatus } from 'components/EmployeeDetails/BankAccountDetails/data';

export const formatPaginationRange = ({
  totalItems,
  currentPage,
  itemsPerPage,
}: {
  totalItems: number;
  currentPage: number;
  itemsPerPage: number;
}) => {
  if (totalItems === 0) {
    return null;
  }

  const startItem = currentPage * itemsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  return `${startItem}-${endItem} of ${totalItems}`;
};

export const verifiedStatuses: Partial<BankAccountVerificationStatus>[] = ['mismatch', 'verified'];
export const unverifiedStatuses: Partial<BankAccountVerificationStatus>[] = [
  'created',
  'failed',
  'invalid',
];

export const isAccountUnverified = (verificationStatus?: BankAccountVerificationStatus) => {
  return verificationStatus ? unverifiedStatuses.includes(verificationStatus) : false;
};

export const isAccountVerified = (verificationStatus?: BankAccountVerificationStatus) => {
  return verificationStatus ? verifiedStatuses.includes(verificationStatus) : false;
};

export const getVerificationStatusTitle = (verificationStatus: BankAccountVerificationStatus) => {
  if (verificationStatus === bankAccountVerificationStatus.mismatch) {
    return 'No Match';
  }
  if (verificationStatus === bankAccountVerificationStatus.verified) {
    return 'Match';
  }
  return 'Unverified';
};

export const getVerificationStatusColor = (
  verificationStatus: BankAccountVerificationStatus,
): BadgeProps['color'] => {
  if (verificationStatus === bankAccountVerificationStatus.verified) {
    return 'positive';
  }
  return 'notice';
};
